export const RootEntityName = 'Model';
export const RootEntityField = 'target';
export const InverseEntityField = 'source';
//# sourceMappingURL=consts.js.map